<template>
  <div class="course-hour-module">
    <el-dialog title="查看课时" :visible.sync="dialogVisible" width="980px" append-to-body :before-close="handleClose">
      <el-form :model="filter" label-width="76px" size="small" inline>
        <el-form-item label="课时名称">
          <el-input v-model="filter.lesperiodName" placeholder="请输入课时名称" clearable />
        </el-form-item>
        <!-- <el-form-item label="课时类型">
          <el-select v-model="filter.lespType">
            <el-option label="云直播" :value="1"></el-option>
            <el-option label="录播课" :value="2"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button type="" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <el-card>
        <el-tabs v-model="chapterId" class="custom-tabs" @tab-click="search">
          <el-tab-pane label="全部" name="all" />
          <el-tab-pane v-for="item of chapterList" :key="item.id" :label="item.name" :name="item.id" />
        </el-tabs>
        <el-button v-if="!readonly" v-show="chapterId && chapterId !== 'all'" type="primary" size="small" style="margin-bottom: 10px;" @click="addBing">添加绑定</el-button>
        <el-table :data="hourList" border>
          <el-table-column align="center" label="排序号" prop="sortNum">
            <template v-slot="{ row }">
              <el-input-number :value="row.sortNum" step-strictly :controls="false" class="edit-sort-num" @change="handleChangeSortNum(row.id, row.sortNum, $event)" />
            </template>
          </el-table-column>
          <el-table-column align="center" label="课时名称" prop="lespName" />
          <el-table-column align="center" label="课时类型" prop="lespType" min-width="120">
            <template v-slot="{ row }">
              <span v-if="row.lespType === '1'">云直播</span>
              <span v-else-if="row.lespType === '2'">录播课</span>
            </template>
          </el-table-column>
          <el-table-column v-if="!readonly" label="课时状态" align="center" prop="shelfFlag">
            <template v-slot="{ row }">
              <span v-if="row.shelfFlag === 1">已下架</span>
              <span v-if="row.shelfFlag === 2">已上架</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="开课时间" prop="beginDate" min-width="120" />
          <el-table-column align="center" label="结课时间" prop="endDate" min-width="120" />
          <el-table-column v-if="!readonly" align="center" label="操作" min-width="80">
            <template v-slot="{ row }">
              <el-button type="text" @click="del(row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 10px; text-align: center;"
          :current-page="filter.page"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="filter.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </el-card>
      <span slot="footer" class="dialog-footer" />
    </el-dialog>
    <!-- 添加绑定 -->
    <el-dialog title="添加绑定" :visible.sync="bingDialogVisible" width="820px" :before-close="handleCloseBing">
      <el-form :model="bingFilter" label-width="80px" size="small" inline>
        <el-form-item label="课时名称" prop="name">
          <el-input v-model="bingFilter.name" placeholder="请输入课时名称" />
        </el-form-item>
        <el-form-item label="课时类型">
          <el-select v-model="bingFilter.type">
            <el-option label="云直播" value="1"></el-option>
            <el-option label="录播课" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchHour">搜索</el-button>
          <el-button type="" @click="resetHour">重置</el-button>
        </el-form-item>
      </el-form>
      <el-card>
        <el-table
          :data="allHours"
          style="width: 100%"
          border
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" align="center" width="55" :selectable="selectableFun" />
          <el-table-column label="课时名称" align="center" prop="name" />
          <el-table-column label="课时类型" align="center" prop="type">
            <template v-slot="{ row }">
              <span v-if="row.type === 1">云直播</span>
              <span v-if="row.type === 2">录播课</span>
            </template>
          </el-table-column>
          <el-table-column width="180px" label="开课时间" align="center" prop="beginDate">
            <template v-slot="{ row }">
              <span>{{ row.beginDate || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column width="180px" label="结课时间" align="center" prop="endDate">
            <template v-slot="{ row }">
              <span>{{ row.endDate || '--' }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 10px; text-align: center;"
          :current-page="bingFilter.page"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="bingFilter.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="bingFilterTotal"
          @size-change="handleBingFilterSizeChange"
          @current-change="handleBingFilterCurrentChange"
        />
      </el-card>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleCloseBing">取 消</el-button>
        <el-button type="primary" size="small" @click="bingHour()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getChapterIdList,
  getHourByCourseId,
  updateCourseLesperiod,
  bindCourseLesperiod,
  delCourseLesperiod
} from '@/api/product/courseManage'
import { getList } from '@/api/class/lesperiod'

export default {
  name: 'CourseHour',

  data() {
    return {
      dialogVisible: false,
      courseId: null,
      chapterList: [],
      chapterId: 'all',
      filter: {
        page: 1,
        limit: 10,
        lesperiodName: null,
        lespType: null
      },
      total: 0,
      hourList: [],
      bingDialogVisible: false,
      bingFilter: {
        page: 1,
        limit: 10,
        name: null,
        type: null
      },
      bingFilterTotal: 0,
      allHours: [],
      lesperiodIds: [],
      readonly: false,
      type: null
    }
  },
  methods: {
    selectableFun(row) {
      if(+row.isBind === 1){
        return false
      }
      return true
    },
    init () {
      const d = this.$options.data()
      this.chapterList = d.chapterList
      this.chapterId = d.chapterId
      this.filter = d.filter
      this.total = d.total
      this.hourList = d.hourList
      this.lesperiodIds = d.lesperiodIds
    },
    show(row, readonly = false) {
      this.init()
      this.courseId = row.id
      this.type = row.type
      this.readonly = readonly
      this.handleGetChapterList()
      this.search()
      this.dialogVisible = true
    },
    // 获取课程章节列表
    handleGetChapterList() {
      getChapterIdList({ courseId: this.courseId }).then(({ code, data }) => {
        if (code === 0) {
          this.chapterList = data
        }
      })
    },
    // 搜索
    search() {
      this.filter.page = 1
      this.getList()
    },
    // 重置
    reset() {
      this.filter = this.$options.data().filter
      this.getList()
    },
    getList() {
      const params = {
        courseId: this.courseId,
        ...this.filter
      }
      if (this.chapterId !== 'all') {
        params.chapterId = this.chapterId
      }
      getHourByCourseId(params).then(({ code, data, message }) => {
        if (code === 0) {
          this.hourList = data.records
          this.total = parseInt(data.total, 10)
        } else {
          this.$message.error(message)
        }
      })
    },
    // 修改排序号
    handleChangeSortNum(id, num, sortNum) {
      updateCourseLesperiod({ id, sortNum })
        .then(({ code }) => {
          if (code === 0) {
            this.$message.success('修改排序号成功!')
            this.handleCloseManage()
            this.getList()
          }
        })
    },
    // 点击新增
    addBing() {
      this.searchHour()
      this.bingDialogVisible = true
    },
    // 搜索待绑定课时列表
    searchHour() {
      this.bingFilter.page = 1
      this.getBingHourList()
    },
    resetHour() {
      this.bingFilter = this.$options.data().bingFilter
      this.getBingHourList()
    },
    getBingHourList() {
      const params = {
        ...this.bingFilter,
        courseId: this.courseId,
        shelfFlag: 2,
        type: this.bingFilter.type
      }
      getList(params).then(({ code, data, message }) => {
        if (code === 0) {
          this.allHours = data.records
          this.bingFilterTotal = parseInt(data.total, 10)
        } else {
          this.$message.error(message)
        }
      })
    },
    // 选择待绑定
    handleSelectionChange(val) {
      this.lesperiodIds = val.map(item => item && item.id)
    },
    // 确认绑定
    bingHour() {
      if(this.lesperiodIds.length === 0) {
        this.$message.warning('请选择课时!')
        return
      }
      const params = {
        courseId: this.courseId,
        lesperiodIds: this.lesperiodIds
      }
      if (this.chapterId !== 'all') {
        params.chapterId = this.chapterId
      }
      bindCourseLesperiod(params).then(({ code }) => {
        if (code === 0) {
          this.$message.success('绑定课时成功!')
          this.bingFilter = this.$options.data().bingFilter;
          this.allHours = []
          this.lesperiodIds = [];
          this.getBingHourList();
          this.search()
        }
      })
    },
    del(id) {
      this.$confirm(`确认删除当前课时?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await delCourseLesperiod({ id })
        if (res.code !== 0) return this.$message.error(res.message)
        this.$message.success('删除成功!')
        this.getList()
      })
    },
    handleClose() {
      this.courseId = null
      this.filter = this.$options.data().filter
      this.hourList = []
      this.dialogVisible = false
      this.$emit('close')
    },
    handleSizeChange(v) {
      this.filter.page = 1
      this.filter.limit = v
      this.getList()
    },
    handleCurrentChange(v) {
      this.filter.page = v
      this.getList()
    },
    handleCloseBing() {
      this.bingFilter = this.$options.data().bingFilter
      this.allHours = []
      this.lesperiodIds = []
      this.bingDialogVisible = false
    },
    handleBingFilterSizeChange(v) {
      this.bingFilter.page = 1
      this.bingFilter.limit = v
      this.getBingHourList()
    },
    handleBingFilterCurrentChange(v) {
      this.bingFilter.page = v
      this.getBingHourList()
    },
  },
}
</script>

<style lang="scss" scoped>
.edit-sort-num {
  width: 100%;
  box-sizing: border-box;
  ::v-deep .el-input__inner {
    border: none;
  }
}
</style>
